"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const aes_1 = __importDefault(require("crypto-js/aes"));
const sha1_1 = __importDefault(require("crypto-js/sha1"));
const enc_utf8_1 = __importDefault(require("crypto-js/enc-utf8"));
function decrypt(text, password) {
    try {
        const hashedPassword = sha1_1.default(password).toString();
        const decryptedHtml = aes_1.default.decrypt(text, hashedPassword).toString(enc_utf8_1.default);
        return decryptedHtml;
    }
    catch (e) {
        return null;
    }
}
exports.default = decrypt;
